export const getAspectRatio = (width: number, height: number) => width / height;
